import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { tinyMenuItems } from "../../utils/navItems";
import NavLinkStyle from "../common/NavigationLinkStyles";
import { MenuProps } from "../common/types";
import styled from "styled-components";
import { Squarebtn } from "../common/squareBtnProps";
import { useTheme as styledTheme } from "styled-components";
import { useAuth } from "../../context/AuthContext";

const TinyMenuCont = styled.div`
  position: absolute;
  z-index: 1000;
  top: 200px;
  left: 30px;
  padding: 20px;
  width: 280px;
  height: auto;
  @media (max-width: 320px) {
    width: 80%;
    height: 70vh;
    overflow-y: auto;
  }
  box-shadow: 0px 1px 12px 1.5px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  background-color: ${({ theme }) => theme.body};

  .content {
    display: flex;
    justify-content: center;
    gap: 20px;
    align-items: center;
    flex-direction: column;
  }

  .name {
    font-weight: 200;
  }
`;

const Profile = styled.div`
  height: 100px;
  width: 100px;
  border-radius: 50%;
  background: ${({ theme }) => theme.containerbg};
`;

const MenuIcon = styled.img`
  width: 17px;
  height: 17px;
  margin-right: 7px;
`;

const TinyMenu: React.FC<MenuProps> = ({ open, onClose, isDarkMode }) => {
  const styledComponentTheme = styledTheme();
  const { logout, loggedInUserName, showAlert } = useAuth();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const tinyMenuElement = document.getElementById("tinyMenu");
      const clickedElement = event.target as HTMLElement;

      // Check if the click is outside the side menu and not on any of the buttons
      if (
        tinyMenuElement &&
        !tinyMenuElement.contains(clickedElement) &&
        !clickedElement.classList.contains("menuCrlBtn")
      ) {
        onClose(); // Close the menu
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose]);

  //hndle logout
  const handleLogout = async () => {
    const shouldLogout = await new Promise<boolean>((resolve) =>
      showAlert(
        false,
        "Logout",
        "You are about to logout, proceed?",
        true,
        undefined,
        () => resolve(true)
      )
    );

    // console.log("Logout btn resolve", shouldLogout);
    if (!shouldLogout) {
      return; //exit if user cancels
    }

    await logout(); // Call the updated logout function onYes
  };

  return (
    <>
      <div>
        <TinyMenuCont id="tinyMenu">
          <div className="content">
            <Profile />

            <p className="name">{loggedInUserName}</p>

            <div>
              <NavLinkStyle
                $padding="8px 10px"
                $fontSize="16PX"
                $fontColor={styledComponentTheme.text}
                $positionCircle="-8px"
                $circleColor={styledComponentTheme.text}
                $margin="0 0 20px 0"
                $bcgClr={styledComponentTheme.tinMenuHover}
                $borderRadius="8px"
              >
                {tinyMenuItems.map((item, index) => (
                  <NavLink key={index} to={item.href} onClick={onClose}>
                    {item.icon && (
                      <MenuIcon
                        src={
                          isDarkMode ? item.icon.iconLight : item.icon.iconDark
                        }
                        alt={`${item.title} icon`}
                      />
                    )}
                    {item.title}
                  </NavLink>
                ))}
              </NavLinkStyle>
            </div>

            <Squarebtn
              width="110px"
              radius="22px"
              height="45px"
              $margin="10px 0 0 0"
              onClick={handleLogout}
              $bacgrndColor={styledComponentTheme.text}
              $color={styledComponentTheme.circularIconTextBg}
              $hoverBackground={styledComponentTheme.tinMenuHover}
              $hoverColor={styledComponentTheme.text}
            >
              Logout
            </Squarebtn>
          </div>
        </TinyMenuCont>
      </div>
    </>
  );
};

export default React.memo(TinyMenu);
